var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6806 12.1946H14.8428M9.36883 12.1946H9.5M12 12.1946H12.1791M21 7.55556C19.3494 4.26283 15.922 2 11.9614 2C8.00083 2 4.6506 4.26283 3 7.55556V3.11111M3 16.4444C4.6506 19.7371 8.07805 22 12.0387 22C15.9992 22 19.3494 19.7371 21 16.4444L21 20.8889M7.65383 8.65009C6.74044 8.65009 6 9.39054 6 10.3039V14.1629C6 15.0762 6.74044 15.8167 7.65383 15.8167H16.2691C17.1825 15.8167 17.923 15.0762 17.923 14.1629V10.3039C17.923 9.39054 17.1825 8.65009 16.2691 8.65009H7.65383Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.730f8340d20331d1d49945dd58465ea6.svg";
export { ForwardRef as ReactComponent };